module.exports = __webpack_public_path__ + "img/pro_six_5.fa29b8f6.jpg";